module.exports = __webpack_public_path__ + "img/elm-mobile.534c544c.png";